/**
 *
 * @param {Number} index
 * @param {HTML} element
 */
function MFRBubbleChecker(index, element) {
  this.$element = $(element);

  this.selectors = {
    bubble: ".bubble",
  };

  this.offset = 26;

  this.init();
}

MFRBubbleChecker.prototype = Object.assign({}, MFRBubbleChecker.prototype, {
  init: function () {
    this.$bubbles = this.$element.find(this.selectors.bubble);

    $(window).on("load", this.__handleBubbleUpdate.bind(this));
    $(window).on("resize", this.__handleBubbleUpdate.bind(this));
  },
  __handleBubbleUpdate: function (event) {
    var self = this;

    this.$bubbles.each(function (i, e) {
      var isExceedsRight =
        $(e).offset().left + $(e).innerWidth() > $(window).width();

      if (isExceedsRight) {
        $(e).css({
          right:
            parseFloat($(e).css("right").replace("px", "")) +
            (self.offset + $(e).offset().left + $(e).innerWidth()) -
            $(window).width() +
            "px",
        });
      }
    });
  },
});